import React, { useState, useEffect } from "react"
import axios from "axios"
import { apiRoot } from './ApiConfig'
import { useNavigate } from "react-router-dom"
import { useGlobal } from './GlobalContext'
import { FiMail, FiLock, FiEye, FiEyeOff, FiLogIn, FiUserPlus, FiCpu } from 'react-icons/fi'
import { ReactComponent as LogoIcon } from './svg/logo.svg'
import './Login.css'


const Login = ({ setIsLoggedIn, setSessionId, setUserEmail, setUserAdmin, server, lsEmail, lsPassword }) => {
	const navigate = useNavigate()

  const { setAdminWatch } = useGlobal()
  const { setUserRole } = useGlobal()
  //const { setSSL } = useGlobal()

  const [email, setEmail] = useState(lsEmail)
  const [password, setPassword] = useState(lsPassword)
  const [message, setMessage] = useState("")
	const [rememberMe, setRememberMe] = useState(true)
  const [mode, setMode] = useState("login")
  const [showPassword, setShowPassword] = useState(false)
  
  // Registration states
  const [newPassword, setNewPassword] = useState("")
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("")
  const [topics, setTopics] = useState([])
  const [selectedTopic, setSelectedTopic] = useState(null)

  const handleLogin = async () => {
    //if (!validateEmail(email) || !validatePassword(password)) {
    if (!validateEmail(email) ) {
      setMessage("Invalid data!");
      return;
    }

    try {
      console.log("API Root:", apiRoot)
      const response = await axios.post(apiRoot + "api/users/login", {
        email,
        password,
      })
      if (response.data.success) {
        console.log("Logged in USER---------------",response.data.results.user)
        setMessage("Login successful!")
        setSessionId(response.data.results.sessionId)
        setUserEmail(email)
        setUserRole(response.data.results.user.role)
        if ( response.data.results.user.role_id === 1 ) {
          setUserAdmin(1)
        } else {
          setUserAdmin(0)
        }
        //setSSL(response.data.results.SSLexpirationDate)

				// lementem az alábbiakat localStorage-ba, az App.js innen olvassa majd
				localStorage.setItem("sessionId", response.data.results.sessionId)
				localStorage.setItem("email", email)
				localStorage.setItem("password", password)
				localStorage.setItem("admin", response.data.results.user.admin)
				localStorage.setItem("role", response.data.results.user.role)

				if (rememberMe) {
					localStorage.setItem("email", email)
					localStorage.setItem("password", password)
				} else {
					localStorage.removeItem("email")
					localStorage.removeItem("password")
				}

				setTimeout(() => {
          setIsLoggedIn(true)
          setAdminWatch(false)
					navigate("/menu")
        }, 500);
      } else {
        setMessage("Invalid Login!")
      }
    } catch (error) {
      setMessage("Webserver error!")
    }
  }

  const validateEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) && email.length <= 60;

  const allowedPasswordCharsRegex = /^[A-Za-z0-9]*$/

  //const validatePassword = (password) => /^\d{6}$/.test(password)

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    //if (/^\d*$/.test(value) && value.length <= 6) {
      setPassword(value)
    //}
  }

  const handleLostPassword = async () => {
    if (!validateEmail(email)) {
      setMessage("Invalid e-mail!")
      return
    }
    try {
      const response = await axios.post(apiRoot + "api/users/lostPassword", {
        email,
      })
      if (response.data.success) {
        setMessage("Password change link sent by e-mail!")
      } else {
        setMessage(response.data.error)
      }
    } catch (error) {
      setMessage("Webserver error!")
    }
  }

  // Registration functions
  const handleRegPasswordChange = (e) => {
    const value = e.target.value;
    if (allowedPasswordCharsRegex.test(value)) {
      if (e.target.id === "pwd1") {
        setNewPassword(value)
      }
      if (e.target.id === "pwd2") {
        setNewPasswordConfirm(value)
      }
    }
  }

  const isStrongPassword = (password) => {
    return (
      password.length >= 12 &&
      /[A-Z]/.test(password) &&
      /[a-z]/.test(password) &&
      /[0-9]/.test(password) &&
      allowedPasswordCharsRegex.test(password)
    )
  }

  useEffect(() => {
    const fetchTopics = async () => {
      try {
        const response = await axios.post(apiRoot + "api/topics/getAllTopicsForRegistration", {})
        if (response.data.success === false) {
          if (response.data.error === "Webserver error!") {
            alert(response.data.error)
          }
        }
        setTopics(response.data.results.topics)
      } catch (error) {
        console.error("Failed to fetch topics:", error)
      }
    }
    if (mode === "register") {
      fetchTopics()
    }
  }, [mode])

  const handleTopicChange = (event) => {
    const selected = topics.find(topic => topic.topic_id === Number(event.target.value))
    setSelectedTopic(selected)
  }

  const handleRegister = async () => {
    if (!validateEmail(email)) {
      setMessage("Invalid e-mail!")
      return
    }
    if (newPassword.trim().length > 0) {
      if (newPassword !== newPasswordConfirm) {
        alert("The passwords don't match!")
        return
      }
      if (!isStrongPassword(newPassword)) {
        alert("Invalid password! At least 12 characters and must contain lowercase and uppercase letters and numbers.")
        return
      }
    } else {
      return
    }
    try {
      const response = await axios.post(apiRoot + "api/users/registration", {
        email: email,
        password: newPassword,
        topicId: selectedTopic.topic_id
      })
      if (response.data.success) {
        setMessage("Registration successful!")
        setEmail("")
        setNewPassword("")
        setNewPasswordConfirm("")
        setSelectedTopic(null)
      } else {
        setMessage("This e-mail is already registered! We have sent you an e-mail to confirm your registration. If you can not find this e-mail, please check your spam folder.")
      }
    } catch (error) {
      setMessage("Registration error!")
    }
  }


  return (
    <div className="lgview">
      <div className="lgpanel">
        <div className="lghead">
          <div className="lgbrand"><LogoIcon height={30} style={{ display: 'flex' }} /></div>
          <h2 className="lgtitle">{mode === "register" ? "Create your account" : "Welcome to VoxDoc"}</h2>
          <p className="lgsub">{mode === "register" ? "Register a new user for this workstation" : "Sign in to start dictating"}</p>
        </div>

        <div className="lgform">
          {mode === "register" ? (
            <>
              <label className="lgfield">
                <span className="lgfield__lbl">Email</span>
                <span className="lgfield__box">
                  <FiMail size={17} />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="name@hospital.org"
                  />
                </span>
              </label>
              <label className="lgfield">
                <span className="lgfield__lbl">Password (At least 12 characters)</span>
                <span className="lgfield__box">
                  <FiLock size={17} />
                  <input
                    id="pwd1"
                    type={showPassword ? "text" : "password"}
                    value={newPassword}
                    onChange={handleRegPasswordChange}
                    placeholder="••••••••"
                    onKeyDown={(e) => {
                      if (e.key === " ") e.preventDefault()
                    }}
                  />
                  <button
                    type="button"
                    className="lgpeek"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label="Toggle password"
                  >
                    {showPassword ? <FiEyeOff size={17} /> : <FiEye size={17} />}
                  </button>
                </span>
              </label>
              <span className="lgfield__lbl" style={{fontSize: '11px', color: '#8395A3'}}>
                Allowed characters: a-z, A-Z, 0-9
              </span>
              <label className="lgfield">
                <span className="lgfield__lbl">Confirm Password</span>
                <span className="lgfield__box">
                  <FiLock size={17} />
                  <input
                    id="pwd2"
                    type={showPassword ? "text" : "password"}
                    value={newPasswordConfirm}
                    onChange={handleRegPasswordChange}
                    placeholder="••••••••"
                    onKeyDown={(e) => {
                      if (e.key === " ") e.preventDefault()
                    }}
                  />
                </span>
              </label>
              <label className="lgfield">
                <span className="lgfield__lbl">Select default topic (Required)</span>
                <span className="lgfield__box">
                  <select
                    className="lgselect"
                    onChange={handleTopicChange}
                    value={selectedTopic ? selectedTopic.topic_id : ""}
                  >
                    <option value="">Select topic...</option>
                    {topics.map((topic) => (
                      <option key={topic.topic_id} value={topic.topic_id}>{topic.name}</option>
                    ))}
                  </select>
                </span>
              </label>
            </>
          ) : (
            <>
              <label className="lgfield">
                <span className="lgfield__lbl">Email</span>
                <span className="lgfield__box">
                  <FiMail size={17} />
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder="name@hospital.org"
                  />
                </span>
              </label>
              <label className="lgfield">
                <span className="lgfield__lbl">Password</span>
                <span className="lgfield__box">
                  <FiLock size={17} />
                  <input
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={handlePasswordChange}
                    placeholder="••••••••"
                  />
                  <button
                    type="button"
                    className="lgpeek"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label="Toggle password"
                  >
                    {showPassword ? <FiEyeOff size={17} /> : <FiEye size={17} />}
                  </button>
                </span>
              </label>

              <label className="lgcheckbox">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={() => setRememberMe(!rememberMe)}
                />
                <span>Remember me</span>
              </label>

              <button className="lglocal" type="button" onClick={handleLostPassword}>
                <FiCpu size={15} />
                <span>Lost password</span>
              </button>
            </>
          )}
        </div>

        <div className="lgactions">
          {mode === "register" ? (
            <>
              <button
                className="lgbtn lgbtn--primary"
                onClick={handleRegister}
                disabled={!(selectedTopic && selectedTopic.topic_id > -1)}
                style={!(selectedTopic && selectedTopic.topic_id > -1) ? { opacity: 0.7, cursor: 'not-allowed' } : {}}
              >
                <FiUserPlus size={18} />
                <span>Create account</span>
              </button>
              <button className="lgbtn lgbtn--ghost" onClick={() => setMode("login")}>
                Back to sign in
              </button>
            </>
          ) : (
            <>
              <button className="lgbtn lgbtn--primary" onClick={handleLogin}>
                <FiLogIn size={18} />
                <span>Sign in</span>
              </button>
              <button className="lgbtn lgbtn--ghost" onClick={() => setMode("register")}>
                <FiUserPlus size={17} />
                <span>Register new user</span>
              </button>
            </>
          )}
        </div>

        {message && <p className="lgfoot">{message}</p>}
        {!message && <p className="lgfoot">Protected workstation · contact your administrator for access</p>}
      </div>
    </div>
  )
}

export default Login
